import { Dialog } from "primereact/dialog";
import { ISubvendorInvoiceList } from "./Table";
import { Button } from "primereact/button";
import { useState } from "react";
import { JVDropdown } from "../../shared/JVDropdown";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import { useForm } from "react-hook-form";
import { Fetch } from "../../shared/Fetch";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { format } from "date-fns";

interface IProps {
    open: boolean,
    tableData: ISubvendorInvoiceList[],
    hideDialoge: () => void,
    toast: any
}

const schema = yup.object({
    paymentStatus: yup.string().required("Payment Status is Required"),
});

const Payment_Status = [
    { name: "-- SELECT --", value: null },
    { name: "Pending", value: "Pending" },
    { name: "In Process", value: "In Process" },
    { name: "Released", value: "Released" },
    { name: "Released In Advance", value: "Released In Advance" },
];

export const BulkPaymentStatusUpdate = (props: IProps) => {
    const [loading, setLoading] = useState<boolean>(false);

    const { control, handleSubmit, formState: { errors }, reset, watch, setValue, setError, setFocus } = useForm<{ paymentStatus: string | null }>({
        resolver: yupResolver(schema),
        defaultValues: { paymentStatus: null },
        shouldFocusError: false
    });

    const fromDate = (rowData: any) => {
        let date;
        if (rowData.fromDate) date = format(new Date(rowData.fromDate), 'dd/MM/yyyy').toUpperCase();
        else date = "";
        return (<>{date}</>);
    };
    const toDate = (rowData: any) => {
        let date;
        if (rowData.toDate) date = format(new Date(rowData.toDate), 'dd/MM/yyyy').toUpperCase();
        else date = "";
        return (<>{date}</>);
    };
    const dueDate = (rowData: any) => {
        let date;
        if (rowData.dueDate) date = format(new Date(rowData.dueDate), 'dd/MM/yyyy').toUpperCase();
        else date = "";
        return (<>{date}</>);
    };

    const onHide = () => {
        reset({ paymentStatus: null });
        props.hideDialoge();
    }

    const onSubmit = async (data: any) => {
        setLoading(true);
        const response = await Fetch("InvoiceTracking/subvendorInvoiceBulkUpdatePaymentStatus", "PUT", null, `status=${data.paymentStatus}&invoiceIDs=${props.tableData.filter((el: ISubvendorInvoiceList) => el.id != null).map((el: ISubvendorInvoiceList) => el.id)}`, props.toast);
        if (response) {
            props.toast.current.show({ severity: 'success', detail: "Payment Updated Successfully", life: 3000 });
            setLoading(false);
            onHide();
        } else {
            props.toast.current.show({ severity: 'error', detail: "Something Went Wrong", life: 3000 });
            setLoading(false);
        }
    }

    return (
        <Dialog visible={props.open} style={{ width: '80vw' }} header="Bulk Update Subvendor Invoice Payment Status" modal className="p-fluid" onHide={onHide}>
            <form onSubmit={handleSubmit(onSubmit)} className="p-fluid formgrid grid">
                <JVDropdown required column={3} label="Payment Status" control={control} name="paymentStatus" options={Payment_Status} optionLabel="name" optionValue="value" placeholder="Select Payment Status" error={errors.paymentStatus?.message} />
                <div className="col-12 md:col-12" style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', columnGap: '10px', marginTop: '10px' }}>
                    <Button className="field col-12 md:col-6 h-2rem" label="SAVE" type="submit" loading={loading}></Button>
                    <Button className="field col-12 md:col-6 p-button-outlined  h-2rem" label="CLEAR" onClick={() => {
                        reset({ paymentStatus: null });
                    }} type="button"></Button>
                </div>
            </form>
            <div className="mt-3"></div>
            <DataTable style={{ border: '1px solid rgba(105,105,105,0.17)', borderTopWidth: "0" }}
                className="mt-6"
                size="small" stripedRows scrollable scrollHeight="30vh"
                value={props.tableData}
                emptyMessage="No Team Members found."
                loading={loading}
            >
                <Column header="SN." body={(data, options) => options.rowIndex + 1} />
                <Column field="consultant_Name" header="Name" />
                <Column field="vendor_Company_Name" header="Sub Vendor" />
                <Column field="fromDate" header="From Date" body={fromDate} />
                <Column field="toDate" header="To Date" body={toDate} />
                <Column field="dueDate" header="Due Date" body={dueDate} />
                <Column field="workingHours" header="Hours" />
                <Column field="bRate" header="B.Rate" />
                <Column field="paymentStatus" header="SV Payment Status" />
                <Column field="invoiceAmount" header="Inv.Amount" footer={() => {
                    const invAmnt = props.tableData.reduce((sum, item) => sum + (item.invoiceAmount || 0), 0);
                    return <span className="">{invAmnt}</span>;
                }} />
                <Column field="primeVendorPaymentStatus" header="PV PaymentStatus" />
            </DataTable>
        </Dialog>
    );
}